module.exports = __webpack_public_path__ + "img/hive-keychain.74a15ced.png";